export const REDUX_ROOT = 'web3Redux';
